export const requiredAssetsToAssetMap = (requiredAssets) =>
    requiredAssets
        .keys()
        // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        .reduce((assets: any, filename: string) => {
            const key = filename.replace(/^\.\//, '').replace(/\..*$/, '');
            assets[key] = requiredAssets(filename).default || requiredAssets(filename);

            return assets;
        }, {});
